import { useLearnDeckStageValues } from "@-/dev.improve.haniverse.routes.nav.app.learn._lib.card-gestures";

/** Motion identity of the welcome card; the deck's gestures and resets check it. */
export const LEARN_SUMMARY_PRESENTATION_KEY = "learn-summary";

/** The welcome card's motion values, owned by the view so controls below the card can follow a drag. */
export function useLearnSummaryFlashcardStage() {
  return useLearnDeckStageValues(LEARN_SUMMARY_PRESENTATION_KEY);
}
